import React, { useState, useEffect } from "react";
import api from "../../api";
import SearchIcon from "@material-ui/icons/Search";
import utils from "../../utils/utils";
import { makeStyles } from "@material-ui/core/styles";
import ReactSelect from "react-select";
import EmailList from "../email/EmailList";
import {
  Paper,
  Grid,
  FormControl,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
const useStyles = makeStyles({
  paperFullWidth: {
    overflowY: "visible",
    maxWidth: 300,
  },
  dialogContentRoot: {
    overflowY: "visible",
  },
});

export default function Email({ setIsLoading, setDataToast }) {
  let navigate = useNavigate();
  const itemsPerPage = 10;
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const [dataTable, setDataTable] = useState();
  const [companiesListCreate, setCompaniesListCreate] = useState([]);
  const [companiesList, setCompaniesList] = useState();
  const [mailTypeList, setMailTypeList] = useState();
  const [templateMailList, setTemplateMailList] = useState();
  const [paginationData, setPaginationData] = useState({
    count: 0,
    currentPage: 1,
  });
  const [createValues, setCreateValues] = useState({
    id: undefined,
    mailTypeId: "",
    templateMailId: "",
    companyId: "",
  });

  const handleClickOpen = () => {
    setCreateValues({
      id: undefined,
      mailTypeId: "",
      templateMailId: "",
      companyId: "",
    });
    setOpen(true);
  };
  const shortError = (message) => {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  };
  function search(e) {
    e.preventDefault();
    reloadData(1, true);
  }
  function reloadData(page, reloadPages) {
    setIsLoading(true);
    let companyId = filterData.companiesList;
    api
      .getTemplatesMailsByCompanyList(companyId, page, 10)
      .then((res) => {
        let data = res.data;
        let currentPage = page;
        let count = paginationData.count;

        if (reloadPages) {
          if (currentPage !== 1) currentPage = 1;
          count = Math.ceil(data.cantidad / itemsPerPage);
        }

        setPaginationData({
          count: count,
          currentPage: currentPage,
        });
        let list = [];

        data.emailTemplatesResponse.forEach((item) => {
          list.push({
            id: item.id,
            companyId: item.compania.id,
            companyName: item.compania.nombre,
            mailTypeId: item.tipoMail.id,
            mailTypeName: item.tipoMail.nombre,
            templateId: item.plantilla.id,
            templateName: item.plantilla.nombre,
          });
        });
        setDataTable(list);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error.");
      });
  }
  const [filterData, setFilterData] = useState({
    companiesList: undefined,
    name: undefined,
  });

  const handleInputChangeCompanyId = (e) => {
    setCreateValues({ ...createValues, companyId: e.key });
  };
  const handleInputChangeMailTypeId = (e) => {
    setCreateValues({ ...createValues, mailTypeId: e.key });
  };
  const handleInputChangeTemplateMailId = (e) => {
    setCreateValues({ ...createValues, templateMailId: e.key });
  };

  const onClickCreate = () => {
    if (checkValueTemplateMailAssignment()) {
      var body = {
        tipoMailId: createValues.mailTypeId,
      };
      api
        .postTemplatesMailsByCompany(
          createValues.templateMailId,
          createValues.companyId,
          body
        )
        .then(() => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Template de mail asigando correctamente.",
            type: "success",
          });
          reloadData(1, true);
          setOpen(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
          setOpen(false);
        });
      setCreateValues({
        id: undefined,
        mailTypeId: "",
        templateMailId: "",
        companyId: "",
      });
    } else if (!createValues.mailTypeId) {
      shortError("Debe ingresar un Tipo de Mail");
    } else if (!createValues.templateMailId) {
      shortError("Debe ingresar un Template");
    } else if (!createValues.companyId) {
      shortError("Debe seleccionar una Compañía");
    }
  };

  const checkValueTemplateMailAssignment = () => {
    let response = false;

    if (
      createValues.companyId &&
      createValues.mailTypeId &&
      createValues.templateMailId
    ) {
      response = true;
    }

    return response;
  };

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      api.getCompanies(),
      api.getEmailTypeList(),
      api.getTemplatesList(),
    ])
      .then((res) => {
        setCompaniesList(utils.setDataInSearchList(res[0].data));
        setCompaniesListCreate(utils.setDataInSearchList(res[0].data));
        setMailTypeList(utils.setDataInSearchList(res[1].data));
        setTemplateMailList(utils.setDataInSearchList(res[2].data));
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={6}>
                <h2>ASIGNAR TEMPLATES DE MAIL</h2>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  className="c-grid-btn c-btn-success"
                  color="primary"
                  onClick={() => handleClickOpen()}
                >
                  Asignar Nuevo
                </Button>

                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  aria-labelledby="form-dialog-title"
                  fullWidth={true}
                  classes={{
                    paperFullWidth: classes.paperFullWidth,
                  }}
                >
                  <DialogTitle id="form-dialog-title">
                    Asignar Nuevo
                  </DialogTitle>
                  <DialogContent
                    classes={{
                      root: classes.dialogContentRoot,
                    }}
                    style={{ maxWidth: 300 }}
                  >
                    <ReactSelect
                      styles={{ maxWidth: 350 }}
                      placeholder="Asociar compañía..."
                      options={companiesListCreate}
                      onChange={handleInputChangeCompanyId}
                    />
                  </DialogContent>
                  <DialogContent
                    classes={{
                      root: classes.dialogContentRoot,
                    }}
                    style={{ maxWidth: 300 }}
                  >
                    <ReactSelect
                      styles={{ maxWidth: 350 }}
                      placeholder="Asociar tipo de mail..."
                      options={mailTypeList}
                      onChange={handleInputChangeMailTypeId}
                    />
                  </DialogContent>
                  <DialogContent
                    classes={{
                      root: classes.dialogContentRoot,
                    }}
                    style={{ maxWidth: 300 }}
                  >
                    <ReactSelect
                      styles={{ maxWidth: 350 }}
                      placeholder="Asociar template..."
                      options={templateMailList}
                      onChange={handleInputChangeTemplateMailId}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setOpen(false)}
                      className="c-btn-cancel"
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={() => onClickCreate()}
                      className="c-btn-success"
                    >
                      Aceptar
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>

              <Grid item xs={12}>
                <form onSubmit={search}>
                  <Grid container spacing={1}>
                    <Grid item md={3} xs={12}>
                      <FormControl
                        variant="outlined"
                        fullWidth={true}
                        size="small"
                      >
                        <ReactSelect
                          placeholder="Buscar por compañías..."
                          name="companiesList"
                          onChange={(e) => {
                            setFilterData({
                              ...filterData,
                              companiesList: e ? e.value : undefined,
                            });
                          }}
                          options={companiesList}
                          isClearable={true}
                          required
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Button
                        className="c-btn-info c-mt-2"
                        variant="contained"
                        fullWidth={true}
                        type="submit"
                        startIcon={<SearchIcon />}
                        onClick={() => navigate("/email")}
                      >
                        Buscar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <EmailList
        setIsLoading={setIsLoading}
        setDataToast={setDataToast}
        dataTable={dataTable}
        classes={classes}
        setDataTable={setDataTable}
        shortError={shortError}
        reloadData={(page, reloadPage) => reloadData(page, reloadPage)}
        paginationData={paginationData}
      />
    </>
  );
}
